const getCurrentUnixTimestamp = () => {
  return Date.now();
};

const config = {
  LOGIN_MODE_URL: `${process.env.REACT_APP_LOGIN_MODE_URL}?time=${getCurrentUnixTimestamp()}`,
  GUEST_MODE_URL: `${process.env.REACT_APP_GUEST_MODE_URL}?time=${getCurrentUnixTimestamp()}`,
  ONGOING_RIDES_URL: `${process.env.REACT_APP_ONGOING_RIDES_URL}?time=${getCurrentUnixTimestamp()}`,
  UPCOMING_RIDES_URL: `${process.env.REACT_APP_UPCOMING_RIDES_URL}?time=${getCurrentUnixTimestamp()}`,
}
export default config;
